import React, { useEffect } from 'react';
import Divider from 'src/components/ui/Divider/Divider';
import styles from 'src/components/layouts/ActionMenu/ActionMenu.module.scss';
import { useTranslation } from 'react-i18next';
import { useOutsideClick } from 'src/hooks/utils';
import Icon from '../../ui/Icon/Icon';
import Input from '../../ui/Input/Input';
import Image from '../../ui/Image/Image';
import Button, { ButtonToneProps } from '../../ui/Button/Button';

export type ListItemsMenuProps = {
  items: any[];
  title: string;
  onClose: () => void;
  type: string;
  onSelect: (item: any) => void;
  onSelectAll?: (items: any[]) => void;
  searchString?: string;
};

const ListItemsMenu: React.FC<ListItemsMenuProps> = ({
  items,
  onClose,
  title,
  type,
  onSelect,
  onSelectAll,
  searchString,
}) => {
  const { t } = useTranslation();
  const [search, setSearch] = React.useState('');
  const menuRef = React.useRef<HTMLDivElement>(null);
  useOutsideClick(menuRef, () => onClose());
  useEffect(() => {
    setSearch(searchString || '');
  }, [searchString]);
  const filteredItems = items.filter(item => item.name.toLowerCase().includes(search.toLowerCase()));
  return (
    <div className={styles.root} ref={menuRef}>
      <div className="flex flex-col w-full px-[1.25rem] max-h-[22.5rem] md:max-h-[30rem]">
        <div className="flex w-full items-center justify-between py-[8px]">
          <span className="typo-text-16--bold">{title}</span>
          <div className="cursor-pointer" role="none" onClick={() => onClose()}>
            <Icon name="close" width={20} height={20} className="cursor-pointer text-faded" />
          </div>
        </div>
        <Input
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeholder={t('navbar.search')}
          className="w-full"
          icon="search"
        />
        {onSelectAll && filteredItems.length > 0 && (
          <div className="mt-8">
            <Button
              icon="plus"
              title={t('general.select_all')}
              tone={ButtonToneProps.SECONDARY}
              onClick={() => onSelectAll(filteredItems)}
            />
          </div>
        )}
        <div className="flex flex-col w-full overflow-y-auto mt-8">
          {filteredItems.map((item, index) => (
            <div key={item.id} className="flex flex-col w-full">
              <div
                className="flex items-center gap-[12px] mt-[12px] cursor-pointer hover:surface-elevated-more p-2 rounded"
                onClick={() => onSelect(item)}
                role="none">
                <Image
                  imageUrl={type === 'carrier' ? item?.logo_url : item?.flag_url}
                  alt="logo"
                  className={`w-[28px] h-[28px] ${type === 'carrier' ? 'rounded-[8px]' : 'rounded-full'}`}
                  fallbackComponent={<Icon name="package" width={20} height={20} />}
                />
                <span className="typo-text-14--medium">{item?.name}</span>
              </div>
              {index < filteredItems.length - 1 && <Divider className="mt-[12px]" />}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ListItemsMenu;
